import { Component, Input, OnInit } from "@angular/core";
import { ServiceTask } from "src/app/model/model";

@Component({
  selector: "app-little-service-card",
  templateUrl: "./little-service-card.component.html",
  styleUrls: ["./little-service-card.component.css"]
})
export class LittleServiceCardComponent implements OnInit {

  constructor() { }

  @Input()
  serviceTask: ServiceTask;

  ngOnInit(): void {
  }

}
